(() => {
  const initMenu = () => {
    const button = document.querySelector("[data-svq-menu-toggle]");
    const panel = document.querySelector("[data-svq-mobile-nav]");
    if (!button || !panel) return;
    const close = () => {
      button.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
    };
    button.addEventListener("click", () => {
      const next = button.getAttribute("aria-expanded") !== "true";
      button.setAttribute("aria-expanded", String(next));
      panel.setAttribute("aria-hidden", String(!next));
    });
    panel.querySelectorAll("a").forEach((link) => link.addEventListener("click", close));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") close();
    });
  };

  const initCarousel = (root) => {
    const slides = [...root.querySelectorAll("[data-svq-slide]")];
    const dots = [...root.querySelectorAll("[data-svq-dot]")];
    const count = root.querySelector("[data-svq-count]");
    if (!slides.length) return;
    let index = 0;
    let touchStart = null;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, item) => slide.classList.toggle("is-active", item === index));
      dots.forEach((dot, item) => {
        dot.classList.toggle("is-active", item === index);
        dot.setAttribute("aria-current", item === index ? "true" : "false");
      });
      if (count) count.textContent = (index + 1) + " / " + slides.length;
    };
    root.querySelector("[data-svq-prev]")?.addEventListener("click", () => show(index - 1));
    root.querySelector("[data-svq-next]")?.addEventListener("click", () => show(index + 1));
    dots.forEach((dot, item) => dot.addEventListener("click", () => show(item)));
    root.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") show(index - 1);
      if (event.key === "ArrowRight") show(index + 1);
    });
    root.addEventListener("touchstart", (event) => {
      touchStart = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    root.addEventListener("touchend", (event) => {
      if (touchStart === null) return;
      const end = event.changedTouches[0]?.clientX ?? touchStart;
      if (Math.abs(end - touchStart) > 45) show(index + (end < touchStart ? 1 : -1));
      touchStart = null;
    }, { passive: true });
    show(0);
  };

  document.addEventListener("DOMContentLoaded", () => {
    initMenu();
    document.querySelectorAll("[data-sovelique-product-carousel]").forEach(initCarousel);
  });
})();
